import React, { useEffect, useState, useRef } from "react";
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "../../../components/modal/modal";
import ClipLoader from "react-spinners/ClipLoader";
import Question from "./Question";
import {
  addQuestionBulk,
  fetch_institute_testSeries_sectionQuestion,
  updateAllQuestionsMarks,
} from "../../../api/testSeries/testseries";
import { dataLimit } from "../../..";
import { Shimmer } from "react-shimmer";
import useStateRef from "react-usestateref";
import { ImageToQuestionArray } from "../../../api/testSeries/ocr";
import Snackbar from "@material-ui/core/Snackbar";
function SectionQuestions({
  activeSection,
  testSeriesDetails = { languages: ["English", "Hindi"] },
}) {
  const [publishedQuestionCount, setPublishedQuestionCount] = useState(
    activeSection?.publishedQuestionCount
  );
  const [SnackBarMessage, setSnackBarMessage] = useState("");
  const [isSnackBarShow, setIsSnackBarShow] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [addQuestionModalVisible, setAddQuestionModalVisible] = useState(false);
  const [editQuestionMarksModalVisible, setEditQuestionMarksModalVisible] =
    useState(false);
  const [addQuestionsData, setAddQuestionsData] = useState({});
  const [editQuestionMarksData, setEditQuestionMarksData] = useState({});
  const [addingQuestions, setAddingQuestions] = useState(false);
  const [fetcingQuestions, setFetcingQuestions, fetchingQuestionsRef] =
    useStateRef(true);
  const [fetchingMore, setFetchingMore] = useState(false);
  const [editingQuestionMarks, setEditingQuestionMarks] = useState(false);
  const [isLast, setIsLast, isLastRef] = useStateRef(false);
  const [addedQue, setAddedQuestionCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [
    addQuestionFromImageModalVisible,
    setAddQuestionFromImageModalVisible,
  ] = useState(false);
  const imageChooserRef = useRef(null);
  const handleAddQuestionDataInput = (e) => {
    const obj = { ...addQuestionsData };
    obj[e.target.name] = e.target.value;
    setAddQuestionsData(obj);
  };
  const handleEditQuestionMarksDataInput = (e) => {
    const obj = { ...editQuestionMarksData };
    obj[e.target.name] = e.target.value;
    setEditQuestionMarksData(obj);
  };
  const closeSnack = () => {
    setIsSnackBarShow(false);
  };
  const generateNQuestions = (Mops, Nques, Olangs, Qdata) => {
    let Nquestions = [];
    for (let j = 0; j < Nques; j++) {
      const questionObj = {};
      questionObj.type = Qdata.questionType;
      questionObj.testSeriesSectionId = activeSection.id;
      questionObj.posMarks = parseInt(Qdata.marksPerQuestion);
      questionObj.correctPrompt = "1";
      questionObj.negMarks = Qdata.isNegativeMarking
        ? parseInt(Qdata.negativeMarksPerQuestion)
        : 0;
      questionObj.negMarksUnattempted = Qdata.isNegativeMarking
        ? Qdata.negativeMarksPerQuestionUnattempted
        : 0;
      questionObj.questionLanguageVarients = [];
      Olangs.map((item) => {
        const obj = {
          language: item,
          value: "Question",
          options: [],
          solution: "solution",
        };
        for (let i = 0; i < Mops; i++) {
          obj.options.push({
            value: "Option" + (i + 1),
            prompt: i + 1,
            isCorrect: false,
          });
        }
        questionObj.questionLanguageVarients.push(obj);
      });
      Nquestions.push(questionObj);
    }

    return Nquestions;
  };

  const addQuestionHandler = (e) => {
    e.preventDefault();
    setAddingQuestions(true);
    let NQuestions = generateNQuestions(
      addQuestionsData.noOfQptions,
      addQuestionsData.noOfQuestions,
      testSeriesDetails.languages,
      addQuestionsData
    );
    addBulk(NQuestions);
  };

  const addBulk = (unsaved_questions = []) => {
    addQuestionBulk(unsaved_questions, (response) => {
      if (response.status === 200) {
        response.json().then((data) => {
          setAddedQuestionCount(addedQue + unsaved_questions?.length || 0);

          const sectionQuestions = questions[activeSection.id] || [];
          setQuestions((prev) => ({
            ...prev,
            [activeSection.id]: [...sectionQuestions, ...data?.data],
          }));
          setAddQuestionModalVisible(false);
          setAddQuestionFromImageModalVisible(false);
          setAddingQuestions(false);
        });
      }
    });
    setAddQuestionsData({});
  };
  const editQuestionMarksHandler = (e) => {
    e.preventDefault();
    setEditingQuestionMarks(true);
    const marksObj = {};
    marksObj.posMarks = parseInt(editQuestionMarksData.posMarks);
    marksObj.negMarks = editQuestionMarksData.isNegativeMarking
      ? parseInt(editQuestionMarksData.negMarks)
      : 0;
    marksObj.negMarksUnattempted = editQuestionMarksData.isNegativeMarking
      ? parseInt(editQuestionMarksData.negMarksUnattempted)
      : 0;
    marksObj.testSeriesSectionId = activeSection.id;

    updateAllQuestionsMarks(marksObj, (response) => {
      if (response.status === 200) {
        console.log("updated");
      }
    });
    setEditQuestionMarksModalVisible(false);
    setEditingQuestionMarks(false);
  };

  const deleteSectionQuestionAtIndex = (response, index) => {
    if (response.status === 200) {
      const newQuestions = [...questions[activeSection.id]];
      newQuestions.splice(index, 1);
      setQuestions((prev) => ({ ...prev, [activeSection.id]: newQuestions }));
    }
  };

  const fetchQuestionCallback = (response) => {
    if (response.status === 200) {
      response.json().then((data) => {
        console.log(data);
        setIsLast(data.last);
        setQuestions({
          ...questions,
          [activeSection.id]: [
            ...(questions[activeSection.id] || []),
            ...(data?.data?.rows || []),
          ],
        });
        setFetcingQuestions(false);
        setFetchingMore(false);
      });
    } else {
      setFetcingQuestions(false);
      setFetchingMore(false);
    }
  };

  useEffect(() => {
    setFetcingQuestions(true);
    setIsLast(false);
    setOffset(0);
    fetch_institute_testSeries_sectionQuestion(
      activeSection.id,
      0,
      dataLimit,
      fetchQuestionCallback
    );
  }, [activeSection]);

  useEffect(() => {
    if (offset > 0) {
      setFetchingMore(true);
      fetch_institute_testSeries_sectionQuestion(
        activeSection.id,
        offset,
        dataLimit,
        fetchQuestionCallback
      );
    }
  }, [offset]);

  // useEffect(() => {
  //     const handleScroll = () => {

  //         const threshold = 30;
  //         const scrollTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
  //         const scrollHeight = (document.documentElement && document.documentElement.scrollHeight) || document.body.scrollHeight;
  //         const clientHeight = document.documentElement.clientHeight || window.innerHeight;
  //         const scrolledToBottom = Math.ceil(scrollTop + clientHeight + threshold) >= scrollHeight;

  //         if (scrolledToBottom && !isLastRef.current && !fetchingQuestionsMoreRef.current && !fetchingQuestionsRef.current) {
  //             setOffset((prevOffset) => prevOffset + 1);
  //         }
  //     };
  //     window.addEventListener("scroll", handleScroll);
  //     return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const processImageQuestions = async (e) => {
    e.preventDefault();
    console.log(addQuestionsData);
    setAddingQuestions(true);
    const response = await ImageToQuestionArray(addQuestionsData.file);
    if (response.status) {
      const data = response.data;

      parseOCRDataToSectionQuestions(data, addQuestionsData);
    } else {
      setSnackBarMessage("Error in processing image kindly try again");
      setIsSnackBarShow(true);
      setAddingQuestions(false);
    }
  };

  const parseOCRDataToSectionQuestions = (data, Qdata) => {
    const questions = data.map((item) => {
      const questionObj = {};
      questionObj.type = Qdata.questionType;
      questionObj.testSeriesSection = { id: activeSection.id };
      questionObj.posMarks = parseInt(Qdata.posMarks);
      questionObj.negMarks = Qdata.isNegativeMarking
        ? parseInt(Qdata.negMarks)
        : 0;
      questionObj.negMarksUnattempted = Qdata.isNegativeMarking
        ? Qdata.negMarksUnattempted
        : 0;
      questionObj.questionLanguageVarients = [
        {
          value: item.question,
          language: Qdata.language,
          options: item.options.map((item, index) => {
            return {
              prompt: index + 1,
              value: item,
            };
          }),
        },
      ];
      return questionObj;
    });

    addBulk(questions);
  };

  const updatePublishedQuestionCount = (status) => {
    console.log(status);
    if (status) {
      setPublishedQuestionCount(publishedQuestionCount + 1);
    } else {
      setPublishedQuestionCount(publishedQuestionCount - 1);
    }
  };

  const updateItemStatusAtIndex = (index, status) => {
    const newQuestions = [...questions[activeSection.id]];
    newQuestions[index].published = status;
    console.log(newQuestions[index].published);
    setQuestions((prev) => ({ ...prev, [activeSection.id]: newQuestions }));
  };

  console.log(questions);
  return (
    <div>
      <div className="row">
        <div class="ml-auto">
          <div class="btn-group">
            <div>
              {/* <button
                type="button"
                class="btn btn-success mr-3"
                data-toggle="modal"
                data-target="#addSectionModal"
                onClick={() => {
                  setAddQuestionFromImageModalVisible(true);
                }}
              >
                Import from Image
              </button> */}
              <button
                type="button"
                class="btn btn-primary mr-3"
                data-toggle="modal"
                data-target="#addSectionModal"
                onClick={() => {
                  setAddQuestionModalVisible(true);
                }}
              >
                + ADD Questions
              </button>
              <button
                type="button"
                class="btn btn-primary mr-3"
                data-toggle="modal"
                data-target="#editQuestionMarksModal"
                onClick={() => {
                  setEditQuestionMarksModalVisible(true);
                }}
              >
                + Edit Marks For All
              </button>
              {/* <button type="button" class="btn btn-dark mr-3">
                TotalQuestions Published: {publishedQuestionCount}/
                {activeSection?.totalQuestionToBePublished}
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div>
        {fetcingQuestions ? (
          <Shimmer width={"100%"} height={40} />
        ) : (
          questions[activeSection.id]?.map((item, index) => {
            return (
              <Question
                totalQuestionToBePublished={
                  activeSection?.totalQuestionToBePublished
                }
                publishedQuestionCount={publishedQuestionCount}
                updatePublishedQuestionCount={updatePublishedQuestionCount}
                deleteSectionQuestionAtIndex={deleteSectionQuestionAtIndex}
                item={item}
                index={index}
                activeSection={activeSection}
                updateItemStatusAtIndex={updateItemStatusAtIndex}
              />
            );
          })
        )}

        {fetchingMore ? (
          <>
            <Shimmer width={"100%"} height={40} style={{ marginTop: 5 }} />
            <Shimmer width={"100%"} height={40} style={{ marginTop: 5 }} />
            <Shimmer width={"100%"} height={40} style={{ marginTop: 5 }} />
            <Shimmer width={"100%"} height={40} style={{ marginTop: 5 }} />
            <Shimmer width={"100%"} height={40} style={{ marginTop: 5 }} />
          </>
        ) : !isLast ? (
          <button
            aria-label="delete"
            onClick={() => setOffset((prevOffset) => prevOffset + 1)}
            className="btn btn-dark mr-1"
          >
            Load More
          </button>
        ) : null}
      </div>

      <Modal
        visible={addQuestionModalVisible}
        setModalVisible={setAddQuestionModalVisible}
        modalId={"questionAddModal"}
      >
        <form onSubmit={addQuestionHandler}>
          <ModalHeader>
            <h5 className="modal-title">Add Question</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Number of Questions</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    value={addQuestionsData["noOfQuestions"]}
                    name={"noOfQuestions"}
                    placeholder="Number of Questions"
                    onChange={handleAddQuestionDataInput}
                  />
                </div>

                <div className="col-6">
                  <label>Question Type</label>
                  <select
                    required
                    className="form-control"
                    value={addQuestionsData["questionType"]}
                    name={"questionType"}
                    onChange={handleAddQuestionDataInput}
                  >
                    <option value={""}>Select</option>
                    <option value={"MCQ"}>MCQ</option>
                  </select>
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Number of Options</label>
                  <input
                    required
                    type="text"
                    className="form-control"
                    value={addQuestionsData["noOfQptions"]}
                    name={"noOfQptions"}
                    placeholder="Number of Options"
                    onChange={handleAddQuestionDataInput}
                  />
                </div>
                <div className="col-6">
                  <label>Marks per question</label>
                  <input
                    required
                    type="number"
                    className="form-control"
                    value={addQuestionsData["posMarks"]}
                    name={"posMarks"}
                    placeholder="Marks"
                    onChange={handleAddQuestionDataInput}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Negative Marking</label>
                  <input
                    type="checkbox"
                    className="form-control"
                    value={addQuestionsData["isNegativeMarking"]}
                    checked={addQuestionsData["isNegativeMarking"]}
                    placeholder="Negative Marks"
                    name={"isNegativeMarking"}
                    onChange={(e) =>
                      handleAddQuestionDataInput({
                        target: {
                          name: "isNegativeMarking",
                          value: !addQuestionsData["isNegativeMarking"],
                        },
                      })
                    }
                  />
                </div>
              </div>

              {addQuestionsData["isNegativeMarking"] ? (
                <div className="form-row mt-2">
                  <div className="col-6">
                    <label>Negative Marks per question</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addQuestionsData["negMarks"]}
                      name={"negMarks"}
                      placeholder="Marks"
                      onChange={handleAddQuestionDataInput}
                    />
                  </div>
                  <div className="col-6">
                    <label>Negative Marks per question if unattempted</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addQuestionsData["negMarksUnattempted"]}
                      name={"negMarksUnattempted"}
                      placeholder="Marks"
                      onChange={handleAddQuestionDataInput}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button className="btn btn-primary" disabled={addingQuestions}>
              {addingQuestions ? (
                <ClipLoader color="white" loading={addingQuestions} size={20} />
              ) : (
                "Add Questions"
              )}
            </button>
          </ModalFooter>
        </form>
      </Modal>
      <Modal
        visible={addQuestionFromImageModalVisible}
        setModalVisible={setAddQuestionFromImageModalVisible}
        modalId={"addQuestionFromImageModalVisible"}
      >
        <form onSubmit={processImageQuestions}>
          <ModalHeader>
            <h5 className="modal-title">Add Question</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Language</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Language"
                    name={"language"}
                    onChange={handleAddQuestionDataInput}
                  />
                </div>

                <div className="col-6">
                  <label>Question Type</label>
                  <select
                    required
                    className="form-control"
                    value={addQuestionsData["questionType"]}
                    name={"questionType"}
                    onChange={handleAddQuestionDataInput}
                  >
                    <option value={""}>Select</option>
                    <option value={"MCQ"}>MCQ</option>
                  </select>
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Choose Image</label>
                  <input
                    required
                    type="file"
                    className="form-control"
                    name={"file"}
                    placeholder="Choose Image"
                    onChange={(e) =>
                      handleAddQuestionDataInput({
                        target: { name: "file", value: e.target.files[0] },
                      })
                    }
                  />
                </div>
                <div className="col-6">
                  <label>Marks per question</label>
                  <input
                    required
                    type="number"
                    className="form-control"
                    value={addQuestionsData["posMarks"]}
                    name={"posMarks"}
                    placeholder="Marks"
                    onChange={handleAddQuestionDataInput}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Negative Marking</label>
                  <input
                    type="checkbox"
                    className="form-control"
                    value={addQuestionsData["isNegativeMarking"]}
                    checked={addQuestionsData["isNegativeMarking"]}
                    placeholder="Negative Marks"
                    name={"isNegativeMarking"}
                    onChange={(e) =>
                      handleAddQuestionDataInput({
                        target: {
                          name: "isNegativeMarking",
                          value: !addQuestionsData["isNegativeMarking"],
                        },
                      })
                    }
                  />
                </div>
              </div>

              {addQuestionsData["isNegativeMarking"] ? (
                <div className="form-row mt-2">
                  <div className="col-6">
                    <label>Negative Marks per question</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addQuestionsData["negMarks"]}
                      name={"negMarks"}
                      placeholder="Marks"
                      onChange={handleAddQuestionDataInput}
                    />
                  </div>
                  <div className="col-6">
                    <label>Negative Marks per question if unattempted</label>
                    <input
                      type="text"
                      className="form-control"
                      value={addQuestionsData["negMarksUnattempted"]}
                      name={"negMarksUnattempted"}
                      placeholder="Marks"
                      onChange={handleAddQuestionDataInput}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button className="btn btn-primary" disabled={addingQuestions}>
              {addingQuestions ? (
                <ClipLoader color="white" loading={addingQuestions} size={20} />
              ) : (
                "Add Questions"
              )}
            </button>
          </ModalFooter>
        </form>
      </Modal>
      <Modal
        visible={editQuestionMarksModalVisible}
        setModalVisible={setEditQuestionMarksModalVisible}
        modalId={"editQuestionMarksModal"}
      >
        <form onSubmit={editQuestionMarksHandler}>
          <ModalHeader>
            <h5 className="modal-title">Add Question</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              {" "}
              <span aria-hidden="true">&times;</span>
            </button>
          </ModalHeader>
          <ModalBody>
            <div>
              <div className="form-row mt-2">
                <div className="col-12">
                  <label>Marks per question</label>
                  <input
                    required
                    type="number"
                    className="form-control"
                    value={editQuestionMarksData["posMarks"]}
                    name={"posMarks"}
                    placeholder="Marks"
                    onChange={handleEditQuestionMarksDataInput}
                  />
                </div>
              </div>
              <div className="form-row mt-2">
                <div className="col-6">
                  <label>Negative Marking</label>
                  <input
                    type="checkbox"
                    className="form-control"
                    value={editQuestionMarksData["isNegativeMarking"]}
                    checked={editQuestionMarksData["isNegativeMarking"]}
                    placeholder="Negative Marks"
                    name={"isNegativeMarking"}
                    onChange={(e) =>
                      handleEditQuestionMarksDataInput({
                        target: {
                          name: "isNegativeMarking",
                          value: !editQuestionMarksData["isNegativeMarking"],
                        },
                      })
                    }
                  />
                </div>
              </div>

              {editQuestionMarksData["isNegativeMarking"] ? (
                <div className="form-row mt-2">
                  <div className="col-6">
                    <label>Negative Marks per question</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editQuestionMarksData["negMarks"]}
                      name={"negMarks"}
                      placeholder="Marks"
                      onChange={handleEditQuestionMarksDataInput}
                    />
                  </div>
                  <div className="col-6">
                    <label>Negative Marks per question if unattempted</label>
                    <input
                      type="text"
                      className="form-control"
                      value={editQuestionMarksData["negMarksUnattempted"]}
                      name={"negMarksUnattempted"}
                      placeholder="Marks"
                      onChange={handleEditQuestionMarksDataInput}
                    />
                  </div>
                </div>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button className="btn btn-primary" disabled={editingQuestionMarks}>
              {editingQuestionMarks ? (
                <ClipLoader
                  color="white"
                  loading={editingQuestionMarks}
                  size={20}
                />
              ) : (
                "Save Changes"
              )}
            </button>
          </ModalFooter>
        </form>
      </Modal>
      <Snackbar
        open={isSnackBarShow}
        onClose={(e) => closeSnack(e)}
        TransitionComponent="TransitionUp"
        message={SnackBarMessage}
      />

      {/* <input type="file" ref={imageChooserRef} onChange={onImageChange} style={{ visibility: "hidden" }} /> */}
    </div>
  );
}

export default SectionQuestions;
